import React from 'react';
import PropTypes from 'prop-types';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import RelativeTime from 'src/components/relativeTime';
import UserLink from 'src/modules/shared/links/userLink';
import Link from 'next/link';
import RouterLink from 'src/modules/shared/links/routerLink';
import signupContext from 'src/constants/signupContext';
import { buildPostQuery } from 'src/utils/router';
import classNames from 'classnames';
import { getElement } from 'src/utils/parserHTML';
import Badge from 'src/components/badges/badge';
import PostLink from 'src/modules/shared/links/postLink';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import { titleMedium } from 'styles-js/mixins/typography';

const Container = styled.div`
  border: ${({theme}) => theme.greyLine};

  .results-post__body a {
    margin: 0;
  }

  // Hide "Not working as expected?" button
  .youtube-beacon-trigger {
    display: none;
  }
`;

const Header = styled.h2`
  ${titleMedium};
  padding: 35px 0 0 0;
  margin: 15px 0px;
`;

class NextPosts extends React.Component {
  static propTypes = {
    limit: PropTypes.number,
  };

  static defaultProps = {
    limit: 5,
  };

  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  onClick = postId => {
    const postIds = this.props.posts.map(post => post.id);
    trackFootfallEvent(footfallEventTypes.CLICKED_NEXT_POST, {
      postIds,
      postId,
    });
  };

  renderPosts = posts => {
    const { currentUser, community = {}, showSignupModal } = this.props;
    return posts.map(post => {
      const { author, title, group, id } = post;
      const linkToPost = `/${group.groupCode}/posts/${post.id}/${post.urlEncodedTitle}`;
      const isVisitorNoRepliesLink = !currentUser && !post.totalResponses;
      return (
        <div
          className="results-post"
          key={`nextPost-${id}`}
        >
          <h3 className="results-post__title">
            <Link as={linkToPost} href={buildPostQuery(post, group)}>
              <RouterLink
                href={linkToPost}
                onCustomClick={() => {
                  this.onClick(id);
                }}
              >
                {title}
              </RouterLink>
            </Link>
          </h3>
          <div className="results-post__body">
            {getElement(post.enriched.snippet)}
          </div>
          <div className="results-post__footer" >
            <div className="results-post__footer__avatar">
              <UserLink
                avatar={true}
                avatarSize="small"
                isLoggedIn={!!currentUser}
                signupContext={{
                  element: signupContext.element.AVATAR,
                  section: signupContext.section.NEXT_POSTS,
                }}
                user={author}
              />
            </div>
            <div className="results-post__footer__content">
              <div className="results-post__footer__content-title">
                <UserLink
                  isLoggedIn={!!currentUser}
                  signupContext={{
                    element: signupContext.element.USER_LINK,
                    section: signupContext.section.NEXT_POSTS,
                  }}
                  user={author}
                />
                {author.roles && author.roles.length > 0
                && <Badge content={author.roles[0]} />}
                <span
                  className="results-post__footer__content-separator"
                  key="separator"
                >
                  •
                </span>
                <RelativeTime className="results-post__footer__content-time" rawTime={post.dateCreated}
                />
              </div>
              <div>
                <PostLink
                  community={community}
                  disabled={isVisitorNoRepliesLink}
                  extraArgs={{ responses: '' }}
                  post={post}
                  onClick={(e) => {
                    this.onClick(id);
                    if (isVisitorNoRepliesLink) {
                      if (e) {
                        e.preventDefault();
                      }
                      showSignupModal({
                        element: signupContext.element.LINK,
                        section: signupContext.section.NEXT_POSTS,
                      });
                    }
                  }}
                >
                  {post.totalResponses > 0
                    ? (
                      <span className="results-post__footer__content-replies">
                        {post.totalResponses} {post.totalResponses === 1 ? i18n.t('Reply') : i18n.t('Replies')}
                      </span>
                    )
                    : i18n.t('Be the first to reply')}
                </PostLink>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    const { isActive, posts } = this.props;
    const postsToRender = this.state.expanded ? posts : posts.slice(0, 5);
    const iconClassName = classNames({
      icon: true,
      'icon-down-open': !this.state.expanded,
      'icon-up-open': this.state.expanded,
    });
    return (
      <div>
        <Header>{isActive ? i18n.t('Next posts') : i18n.t('You may also like...')}</Header>
        <Container>
          {this.renderPosts(postsToRender)}
          <div className="results__see-more-cta">
            <a
              href="#"
              onClick={e => {
                e.preventDefault();
                this.setState({ expanded: !this.state.expanded });
              }}
            >
              {this.state.expanded ? i18n.t('Show fewer posts') : i18n.t('View more posts')} <span className={iconClassName} />
            </a>
          </div>
        </Container>
      </div>
    );
  }
}

export default NextPosts;
